// @ts-check

import {
  referenceActionIcon,
  referenceActionVariant
} from '@/constants/references'
import { pickTruthy } from '@/helpers/functional'
import * as _ from 'lodash-es'
import { computed, unref } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * @param {import('vue').Ref<HasActionsInterface?>} actionable
 * @param {import('vue').Ref<ActionOptions>} options
 */
export const useActions = (actionable, options) => {
  const { t } = useI18n()

  const parsedActions = computed(() =>
    pickTruthy(actionable.value?.actions).map((action) =>
      action.replace('can_', '')
    )
  )

  /**
   * Returns icon for the given action.
   * @param {string} action
   */
  const getActionIcon = (action) => _.get(referenceActionIcon, action)

  /**
   * Returns variant (color scheme) for the given action.
   * @param {string} action
   */
  const getActionVariant = (action) => _.get(referenceActionVariant, action)

  const mappedActions = computed(() =>
    parsedActions.value.map((action) => ({
      action,
      variant: getActionVariant(action),
      icon: getActionIcon(action),
      event: action,
      params: actionable.value,
      label: t(`${unref(options).labelPath}.${action}`)
    }))
  )

  /**
   * @param {mappedActions['value'][0]} action
   * @param {*} emitter
   */
  const triggerAction = (action, emitter) => {
    emitter(action.action.replace(/_/g, '-'), action.params)
  }

  return {
    parsedActions,
    mappedActions,
    getActionIcon,
    getActionVariant,
    triggerAction
  }
}

export default useActions
